// Connection Status Indicator Component
// Shows Supabase connection status with visual indicator

import React, { useState, useEffect } from 'react';
import { Wifi, WifiOff, Loader2 } from 'lucide-react';
import supabaseConnectionStatus from '../services/supabaseConnectionStatus';

const ConnectionStatusIndicator = ({ className = '' }) => {
  const [status, setStatus] = useState({
    status: 'checking',
    lastChecked: null,
    isConnected: false
  });

  useEffect(() => {
    // Initialize connection monitoring
    supabaseConnectionStatus.initialize();

    // Subscribe to status changes
    const unsubscribe = supabaseConnectionStatus.subscribe((newStatus) => {
      setStatus(newStatus);
    });

    // Cleanup on unmount
    return () => {
      unsubscribe();
      supabaseConnectionStatus.cleanup();
    };
  }, []);

  const getStatusConfig = () => {
    switch (status.status) {
      case 'connected':
        return {
          text: '已連接',
          bgClass: 'bg-green-100 border-green-300',
          textClass: 'text-green-700',
          icon: <Wifi className="w-4 h-4" />
        };
      case 'disconnected':
        return {
          text: '未連接',
          bgClass: 'bg-red-100 border-red-300',
          textClass: 'text-red-700',
          icon: <WifiOff className="w-4 h-4" />
        };
      case 'checking':
        return {
          text: '檢查中...',
          bgClass: 'bg-yellow-100 border-yellow-300',
          textClass: 'text-yellow-700',
          icon: <Loader2 className="w-4 h-4 animate-spin" />
        };
      default:
        return {
          text: '未知',
          bgClass: 'bg-gray-100 border-gray-300',
          textClass: 'text-gray-700',
          icon: <WifiOff className="w-4 h-4" />
        };
    }
  };

  const config = getStatusConfig();

  return (
    <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium border ${config.bgClass} ${config.textClass} ${className}`}>
      {config.icon}
      <span>{config.text}</span>
      {status.status === 'connected' && status.lastChecked && (
        <span className="text-[10px] opacity-70">
          {new Date(status.lastChecked).toLocaleTimeString('zh-TW', { 
            hour: '2-digit', 
            minute: '2-digit' 
          })}
        </span>
      )}
    </div>
  );
};

export default ConnectionStatusIndicator;

